import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Icon,
  FormHelperText,
  FormControl,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import AddEvenlyTable from "./AddEvenlyTable";
import "./salestarget.css";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useLocation } from "react-router-dom";
import UserTargetTable from "./UserTargetTable";
import { useLoading } from "../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { salesTargetDetailsGetById } from "./grphql";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";

const AddSalesTarget = () => {
  const [distrubetEvenlyData, setDistrubetEvenlyData] = useState({
    financialyearStart: "",
    financialyearEnd: "",
    maximumAmount: "",
    minimumAmount: "",

    maximumAmountStatus: "",
    minimumAmountStatus: "",
  });
  const [usersData, setUsersData] = useState([]);
  const [updateData, setUpdateData] = useState(null);
  const [targetValue, setTargetValue] = useState("");
  const { circleLoading, setCirleLoading } = useLoading();
  const [id, setId] = useState(null);
  const location = useLocation();
  const [buttobstate,setbuttonstate] = useState(true)
  const pathid = location.search.slice(1);
  const [minYear, setMinYear] = useState(2025);
  const [maxYear, setMaxYear] = useState(2028);
  const [startYear, setStartYear] = useState(2025);

  // Calculate Start Date and End Date
  //To do- Take the maximum and minimum of the years and create a range for to go front and back

  const startDate = `${startYear || minYear}-04-01`;
  const endDate = `${startYear + 1 || minYear + 1}-03-31`;

  const handleYearChange = (direction) => {
    if (direction === "up" && startYear < maxYear) {
      setStartYear(startYear + 1);
    } else if (direction === "down" && startYear > minYear) {
      setStartYear(startYear - 1);
    }
  };

  useEffect(() => {
    setId(pathid);
  }, [pathid, id]);

  useEffect(() => {
    if (id) {

      const fetchData = async () => {
        try {
          const res = await request(BASEURL, salesTargetDetailsGetById, {
            id: id,
            financialyearEnd: minYear,
          });
          const v = res?.salesTargetDetailsGetById;
          setDistrubetEvenlyData({
            financialyearStart: v?.financialyearEnd,
            financialyearEnd: v?.financialyearEnd,
            maximumAmount: v?.maximumAmount,
            minimumAmount: v?.minimumAmount,
            financialyearStartStatus: "success",
            financialyearEndStatus: "success",
            maximumAmountStatus: "success",
            minimumAmountStatus: "success",
          });

          setMinYear(parseInt(v?.financialyearStart, 10));
          setMaxYear(parseInt(v?.financialyearEnd, 10));
          setStartYear(parseInt(v?.financialyearStart, 10));

          setUpdateData(v?.salestargetSet);
        } catch (err) {
          console.error(err);
        }
      };

      fetchData();
    }
  }, [id]);

  const handledistrubetChange = (event) => {
    let distrubetEvenlyState = { ...distrubetEvenlyData };
    const changeAllowed = true;
    const { name, value } = event.target;
    switch (event.target.name) {
      case "financialyearStart":
        {
          const alphaNLenghthRegex = new RegExp(
            "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
          );

          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            distrubetEvenlyState[event.target.name + "Status"] = "success";
          } else {
            distrubetEvenlyState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "financialyearEnd":
        {
          const alphaNLenghthRegex = new RegExp(
            "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
          );
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            distrubetEvenlyState[event.target.name + "Status"] = "success";
          } else {
            distrubetEvenlyState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
        case "maximumAmount": {
          const alphaNLenghthRegex = new RegExp("^([0-9]{2,15})$");
        
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            distrubetEvenlyState[event.target.name + "Status"] = "success";
        
            // Validate minimumAmount only if it has a value
            if (
              distrubetEvenlyData.minimumAmount &&
              parseFloat(distrubetEvenlyData.minimumAmount) >=
                parseFloat(event.target.value.trim())
            ) {
              distrubetEvenlyState.minimumAmountStatus = "error";
            } else if (distrubetEvenlyData.minimumAmount) {
              distrubetEvenlyState.minimumAmountStatus = "success";
            } else {
              distrubetEvenlyState.minimumAmountStatus = "unchecked"; // No value yet
            }
          } else {
            distrubetEvenlyState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        }
        
        case "minimumAmount": {
          const alphaNLenghthRegex = new RegExp("^([0-9]{2,15})$");
        
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            // Validate against maximumAmount
            if (
              distrubetEvenlyData.maximumAmount &&
              parseFloat(event.target.value.trim()) >=
                parseFloat(distrubetEvenlyData.maximumAmount)
            ) {
              distrubetEvenlyState[event.target.name + "Status"] = "error";
            } else {
              distrubetEvenlyState[event.target.name + "Status"] = "success";
            }
          } else {
            distrubetEvenlyState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        }
        
        
        
        
      default:
        break;
    }
    // if (changeAllowed) {
    //   distrubetEvenlyState[event.target.name] = event.target.value;

    // //   if(distrubetEvenlyData.maximumAmount){

    // //      Number(distrubetEvenlyData.maximumAmount)>Number(distrubetEvenlyData.minimumAmount)?setbuttonstate(false):setbuttonstate(true)       
    // //  }

    // // else if(distrubetEvenlyData.minimumAmount){

    // //   Number(distrubetEvenlyData.minimumAmount)<Number(distrubetEvenlyData.maximumAmount)? setbuttonstate(false):setbuttonstate(true)
        
    // // }  
    //   //  distrubetEvenlyData['financialyearStart'] = startDate
    //   //  distrubetEvenlyData['financialyearEnd'] = endDate

    // }

     

    if (changeAllowed) {
      distrubetEvenlyState[event.target.name] = event.target.value;
    
      if (distrubetEvenlyState.maximumAmount && distrubetEvenlyState.minimumAmount) {
        const maxAmount = Number(distrubetEvenlyState.maximumAmount);
        const minAmount = Number(distrubetEvenlyState.minimumAmount);
    
        maxAmount > minAmount ? setbuttonstate(false) : setbuttonstate(true);
      }
    }
    

    setDistrubetEvenlyData(distrubetEvenlyState);

      setDistrubetEvenlyData((prevData) => ({
      ...prevData,
      financialyearStart: startDate,
      financialyearEnd: endDate,
    }));
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      // distrubetEvenlyData.financialyearStartStatus === "success" &&
      // distrubetEvenlyData.financialyearEndStatus === "success" &&
      // distrubetEvenlyData.maximumAmountStatus === "success" &&
      // distrubetEvenlyData.minimumAmountStatus === "success" &&
      // distrubetEvenlyData.maximumAmount>distrubetEvenlyData.minimumAmount
      distrubetEvenlyData.financialyearStart&&distrubetEvenlyData.financialyearEnd
    
      
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleDistbuteEvenly = async () => {
    setCirleLoading(true);
    setTargetValue(distrubetEvenlyData?.maximumAmount);
    setCirleLoading(false);

    const query = `mutation createsalestarget($input:CreateSalesTargetDetailsInput!){
  createSalestargetdetails(input:$input){
    success
  }
}`
   
  let data = {
    financialyearStart : startDate,
    financialyearEnd: endDate,
    maximumAmount: distrubetEvenlyData.maximumAmount,
    minimumAmount: distrubetEvenlyData.minimumAmount
  }

  
   
  };


  // useEffect(() => {
  //   setDistrubetEvenlyData((prevData) => ({
  //     ...prevData,
  //     financialyearStart: startDate,
  //     financialyearEnd: endDate,
  //   }));
  // }, [startDate, endDate]);
  


  


  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {id ? "Update Sales Target" : "Add Sales Target"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1}>
            <CrisisAlertIcon style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Company Goal
            </MaterialTypography>
          </Stack>
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box sx={{ width: "50%" }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                
                >
                  Financial Year <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>

              <Box sx={{ display: "flex", justifyContent: "space-around" }}>
              
              {/* Start Date */}
              <Box >
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Start Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "35px", height: "41px",width:"200px", border: "1px solid #ddd", padding: "5px", borderRadius: "8px" }}>
          <button
            onClick={() => handleYearChange("down")}
            disabled={!startYear || startYear <= minYear}
            style={{
              cursor: !startYear || startYear <= minYear ? "not-allowed" : "pointer",
              padding: "5px",
              backgroundColor: "#98a1d7",
              border: "1px solid #ccc",
              borderRadius: "3px",
            }}
          >
            -
          </button>
          <MaterialTypography variant="caption" fontSize="15px">
            {startDate}
          </MaterialTypography>
          <button
            onClick={() => handleYearChange("up")}
            disabled={!startYear || startYear >= maxYear}
            style={{
              cursor: !startYear || startYear >= maxYear ? "not-allowed" : "pointer",
              padding: "5px",
              backgroundColor: "#98a1d7",
              border: "1px solid #ccc",
              borderRadius: "3px",
            }}
          >
            +
          </button>
        </div>
              </Box>

              {/* End Date */}
              <Box>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    End Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialTypography variant="caption" >
                {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width:"200px" ,gap: "10px", border: "1px solid #ddd", padding: "9px" , borderRadius: "7px", fontSize: "15px"}}> */}
                  <MaterialInput
                  value={endDate}
                  inputProps={{style: {textAlign: "center"}}}
                  disabled>
                      
                  </MaterialInput>
                  
                  {/* </div> */}
                </MaterialTypography>
              </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "end",
                width: "50%",
                justifyContent: "space-around",
              }}
            >
              <Box>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Top Line <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="maximumAmount"
                  type="text"
                  placeholder="Maximum Target"
                  value={distrubetEvenlyData.maximumAmount}
                  onChange={handledistrubetChange}
                  error={
                    distrubetEvenlyData.maximumAmountStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    distrubetEvenlyData.maximumAmountStatus === "success"
                      ? true
                      : false
                  }
                  icon={{
                    direction: "right",
                    component: (
                      <Icon color="action" fontSize="small">
                        <CurrencyRupeeIcon />
                      </Icon>
                    ),
                  }}
                />
              </Box>
              <Box>
                <MaterialBox lineHeight={0} display="inline-block" mb={1} >
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Bottom Line <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="minimumAmount"
                  value={distrubetEvenlyData.minimumAmount}
                  type="text"
                  placeholder="Minimum Target"
                  onChange={handledistrubetChange}
                  error={distrubetEvenlyData.minimumAmountStatus === "error"}
                  success={
                    distrubetEvenlyData.minimumAmountStatus === "success"
                  }
                  icon={{
                    direction: "right",
                    component: (
                      <Icon color="action" fontSize="small">
                        <CurrencyRupeeIcon />
                      </Icon>
                    ),
                  }}
                />
                <div style={{position:"absolute"}}>
               {distrubetEvenlyData.minimumAmountStatus === "error" && (
                                <FormControl error>
                                  <FormHelperText>
                                  Bottom line amount must be less than the top line amount
                                  </FormHelperText>
                                </FormControl>
                              )}
                              </div>
              </Box>
            </Box>
          </Box>
          <MaterialBox
            display="flex"
            justifyContent="end"
            alignItems="center"
            paddingTop="40px"
          >
            <MaterialButton
              variant="gradient"
              color="dark"
              disabled={buttobstate}
              onClick={handleDistbuteEvenly}
            >
              Distribute Evenly
            </MaterialButton>
          </MaterialBox>

          <UserTargetTable
            targetValue={targetValue}
            totalamount={distrubetEvenlyData?.maximumAmount}
            yearData={distrubetEvenlyData}
            updateData={updateData}
            id={id}
          />
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AddSalesTarget;
